/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Requestspeopleaccepted2Inputs */

const en_requestspeopleaccepted2 = /** @type {(inputs: Requestspeopleaccepted2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} people accepted`)
};

const de_requestspeopleaccepted2 = /** @type {(inputs: Requestspeopleaccepted2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Personen angenommen`)
};

/**
* | output |
* | --- |
* | "{count} people accepted" |
*
* @param {Requestspeopleaccepted2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const requestspeopleaccepted2 = /** @type {((inputs: Requestspeopleaccepted2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestspeopleaccepted2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requestspeopleaccepted2(inputs)
	return de_requestspeopleaccepted2(inputs)
});
export { requestspeopleaccepted2 as "requestsPeopleAccepted" }